import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

document.addEventListener('DOMContentLoaded', function () {
    const galleries = document.querySelectorAll('.galleries__gallery');
    galleries.forEach((gallery) => {
        Fancybox.bind(`[data-fancybox="${gallery.id}"]`, {});
    });

    const plantGalleries = document.querySelectorAll('.plants__content-image a[data-fancybox]');
    plantGalleries.forEach((gallery) => {
        Fancybox.bind(`[data-fancybox="${gallery.getAttribute('data-fancybox')}"]`, {});
    });
});